import React, { LegacyRef, MouseEventHandler } from 'react';
import { CTAChevron } from 'assets/helper/icons';

type SlickArrow = {
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  prefix: string;
  refs?: LegacyRef<HTMLButtonElement> ;
}

export function NextArrow(props: SlickArrow) {
  const {
    className,
    onClick,
    refs
  } = props;

  const classes = className ? ` ${className}` : '';

  return (
    <button
      aria-label="next"
      className={ `swiper-button-next--custom${classes}` }
      data-role="none"
      onClick={ onClick }
      ref={ refs }
      type="button"
    >
      <CTAChevron />
    </button>
  )
}

export function PrevArrow(props: SlickArrow) {
  const {
    className,
    onClick,
    refs
  } = props;

  const classes = className ? ` ${className}` : '';

  return (
    <button
      aria-label="previous"
      className={ `swiper-button-prev--custom${classes}` }
      data-role="none"
      onClick={ onClick }
      ref={ refs }
      type="button"
    >
      <CTAChevron />
    </button>
  )
}
